import type { AnalyticsPayload } from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { fireErrorAnalyticsCommon } from '@atlassian/jira-issue-commmon-error-boundary/src/utils/fire-error-analytics/index.tsx';

export const fireIssueTransitionErrorAnalytics = (payload: AnalyticsPayload): void => {
	const { attributes = {}, error, ...otherPayload } = payload;

	fireErrorAnalyticsCommon({
		...otherPayload,
		attributes: {
			...attributes,
		},
		error,
	});
};
